// extracted by mini-css-extract-plugin
export default {"main_div":"EditScreenHeaderInfoDiv_main_div__Rv-0Q","text":"EditScreenHeaderInfoDiv_text__Zf6EO"};